// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1ffea9dc","239":"9eb536f4","455":"a618917f"}[chunkId] + ".chunk.js";
};